import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import SuccessImg from "../../assets/images/success-order.svg";
import SuccessImgFood from "../../assets/images/success-food.svg";
import {
  calculatePriceFractionalToProduct,
  floatToPrice,
} from "../../functions/price_functions";

import { useAppConfig } from "../../hooks/useAppConfig";
import { useEffect, useState } from "react";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";

import "./index.css";
import { useOrder } from "../../hooks/useOrder";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { cpfMask, datetimeToDateBR } from "../../functions/mask";
import {
  OrderAddress,
  OrderType,
  ProductType,
} from "../../contexts/OrderContext";
import { MainButton } from "../../components/MainButton";
import Swal from "sweetalert2";
import { ImageLazy } from "../../components/ImageLazy";
import { useProduct } from "../../hooks/useProduct";
import { ModalCancel } from "../../components/ModalCancel/index";
import { useFoodConfig } from "../../hooks/useFood";

type StatusResponseType = {
  id: number;
  name: string;
  slug: string;
  order: number;
  displayStatusWebapp: boolean;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

export function SuccessOrder() {
  const { organizeFractions } = useProduct();
  const { getAppConfig } = useAppConfig();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const { dencryptOrderStorage } = useOrder();
  const [orderDate, setOrderDate] = useState("");
  const [status, setStatus] = useState<Array<StatusResponseType>>();
  const [statusOrder, setStatusOrder] = useState<StatusResponseType>();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();
  const [type, setType] = useState("");
  const [freight, setFreight] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);
  const [orderFinished, setOrderFinished] = useState<OrderType>();
  const [orderIdExt, setOrderIdExt] = useState("");
  const [typePluginSpace, setTypePluginSpace] = useState<string>("");
  const [observation, setObservation] = useState("");
  const [requestSynkar, setRequestSynkar] = useState("");
  const [externalCodeERP, setExternalCodeERP] = useState("");
  const [sellerInfo, setSellerInfo] = useState<any>(null);
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [internalDelivery, setInternalDelivery] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [location, setLocation] = useState("");

  const { isCard, isTable, tableNumber, cardNumber } = useFoodConfig();

  useEffect(() => {
    registerAccess("success-order");
    getConfig();
    const internalDeliveryNumber = localStorage.getItem("internal_number");
    const internalDeliveryName = localStorage.getItem("internal_name");
    if (internalDeliveryNumber && internalDeliveryName)
      setInternalDelivery(
        `${window.atob(internalDeliveryName)} ${window.atob(
          internalDeliveryNumber,
        )}`,
      );
  }, []);

  async function loadOrder() {
    let orderIdExtNow = "";
    const orderFinalizedStorage = localStorage.getItem("orderFinalized");
    if (orderFinalizedStorage) {
      const orderFinalized = await dencryptOrderStorage(orderFinalizedStorage);
      if (orderFinalized) {
        setLocation(await findLocation(orderFinalized.type));

        setFreight(orderFinalized.freight);
        //setName(customerStorage.name); // Carregando na linha 107
        setType(orderFinalized.type);
        if (
          orderFinalized.orderAddress &&
          orderFinalized.orderAddress.address
        ) {
          setOrderAddress(orderFinalized.orderAddress);
        }
        setTotal(orderFinalized.totalValue);
        setTotalWithoutDiscount(orderFinalized.totalValueWithoutDiscount);
        setOrderFinished(orderFinalized.order);
        setOrderIdExt(
          orderFinalized.orderIdExt ? orderFinalized.orderIdExt : "",
        );
        orderIdExtNow = orderFinalized.orderIdExt
          ? orderFinalized.orderIdExt
          : "";
      }
    }
    return orderIdExtNow;
  }

  async function findLocation(type: string) {
    return await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: LocationResponseType) => location.code == type,
        );
        return location ? location.name : "Entrega";
      })
      .catch((err) => {
        console.log(err);
        return "Entrega";
      });
  }

  async function getConfig() {
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    const type = await getThisPluginspace();

    setTypePluginSpace(type!.type);

    const orderIdExtNow = await loadOrder();
    await getOrder(orderIdExtNow);

    setInterval(async () => {
      if (window.location.pathname.includes("success-order")) {
        await getOrder(orderIdExtNow);
      }
    }, 30000);

    await getStatus();

    setLoading(false);
  }

  async function getOrder(orderIdExtNow?: string) {
    await api
      .post(
        `/api/orders/ext/${orderIdExtNow ? orderIdExtNow : orderIdExt}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then((response) => {
        const orderResponse = response.data;
        if (orderResponse) {
          setOrderDate(datetimeToDateBR(orderResponse.data[0].created));
          setObservation(orderResponse.data[0].observation);
          setName(orderResponse.data[0].content.customer);
          if (orderResponse.data[0].type === "synkar") {
            const statusNow = orderResponse.data[0].orderStatus.sort(
              (a: any, b: any) => (a.id < b.id ? 1 : b.id < a.id ? -1 : 0),
            );
            const statusChange = orderResponse.data[0].status.find(
              (st: any) => st.id === statusNow[0].statusId,
            );
            setStatusOrder(statusChange);
          } else {
            setStatusOrder(orderResponse.data[0].status[0]);
          }

          if (orderResponse.data[0].content.requestSynkar)
            setRequestSynkar(orderResponse.data[0].content.requestSynkar);
          if (orderResponse.data[0].content.externalCodeERP)
            setExternalCodeERP(orderResponse.data[0].content.externalCodeERP);

          if (
            orderResponse.data[0].cartCustomer &&
            orderResponse.data[0].cartCustomer.seller
          ) {
            setSellerInfo(orderResponse.data[0].cartCustomer.seller);
          }
          if (
            (!orderAddress || !orderAddress.address) &&
            orderResponse.data &&
            orderResponse.data[0] &&
            orderResponse.data[0].content &&
            orderResponse.data[0].content.orderAddress
          ) {
            setOrderAddress(orderResponse.data[0].content.orderAddress);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function getStatus() {
    await api
      .get(`/api/status`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        const statusReponse = response.data;
        const sts = statusReponse.data.filter(
          (manyStatus: StatusResponseType) =>
            manyStatus.displayStatusWebapp === true,
        );
        setStatus(
          sts.sort((a: StatusResponseType, b: StatusResponseType) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0,
          ),
        );
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  const unlockSynkar = async () => {
    if (requestSynkar) {
      setLoading(true);
      await api
        .post(
          `/api/pluginconfig/filter`,
          {
            plugintemplateId: 108,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response) => {
          if (
            response.data.data &&
            response.data.data[0] &&
            response.data.data[0].content &&
            response.data.data[0].content.able === "1"
          ) {
            const synkarData = response.data.data[0].content;
            await api
              .post(
                `/api/orders/unlock-synkar`,
                {
                  requestUuid: requestSynkar,
                  operationUuid: synkarData.operationCode,
                  clientId: synkarData.clientId,
                  clientSecret: synkarData.clientSecret,
                  orderIdExt,
                },
                {
                  headers: {
                    Authorization: `Bearer ${await getToken()}`,
                  },
                },
              )
              .then(async (response) => {
                setLoading(false);
                Swal.fire({
                  icon: "success",
                  title: "Trava desbloqueada!",
                  text: "Abra o robô e retire seu pedido.",
                }).then(() => window.location.reload());
              })
              .catch((e) => {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: "Falha ao realizar desbloqueio.",
                });
              });
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Não foi possível capturar dados da integração Synkar.",
            });
          }
        })
        .catch((e) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Não foi possível capturar dados da integração Synkar.",
          });
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro!",
        text: "Não foi possível capturar código do pedido Synkar.",
      });
    }
  };

  function chooseModality() {
    switch (type) {
      case "withdraw":
        return "Retirada";
      case "delivery":
        return "Entrega";
      case "table":
        // ✅ MOSTRAR NÚMERO DA MESA
        if (isTable && tableNumber) {
          return `Mesa - ${tableNumber}`;
        }
        return "Mesa";
      case "card":
        if (isCard && cardNumber) {
          return `Comanda - ${cardNumber}`;
        }
        return "Comanda";
      case "counter":
        return "Retirada Balcão";
      case "synkar":
        const landmark = localStorage.getItem("landmark_synkar");
        if (
          landmark &&
          window.atob(landmark) &&
          JSON.parse(window.atob(landmark))
        ) {
          const landmarkItem = JSON.parse(window.atob(landmark));
          return `${location ? `${location} - ` : ""}${landmarkItem.landmark}`;
        } else return "Entrega";
      case 'pluginbot':
        const landmarkPluginbot = localStorage.getItem("landmark_pluginbot");
        if (landmarkPluginbot && window.atob(landmarkPluginbot) && JSON.parse(window.atob(landmarkPluginbot))) {
          const landmarkPluginbotItem = JSON.parse(window.atob(landmarkPluginbot))
          return `${location ? `${location} - ` : ''}${landmarkPluginbotItem.landmark}`
        }
        else return 'Entrega'
      case "internal-delivery":
        const internalDeliveryNumber = localStorage.getItem("internal_number");
        const internalDeliveryName = localStorage.getItem("internal_name");
        if (internalDeliveryNumber && internalDeliveryName)
          return `Entrega - ${window.atob(internalDeliveryName)} ${window.atob(
            internalDeliveryNumber,
          )}`;
        else return "Entrega Interna";
      default:
        return "Retirada";
    }
  }

  function chooseTextAddress(typeAddress: string) {
    let textAddress = "";
    switch (typeAddress) {
      case "withdraw":
        textAddress = "Endereço de Retirada: ";
        break;
      case "delivery":
        textAddress = "Endereço de Entrega: ";
        break;
      case "internal-delivery":
        textAddress = "Local de Entrega: ";
        break;
    }
    if (textAddress && orderAddress) {
      return (
        <p>
          <b>{textAddress}</b>
          {internalDelivery ? (
            <>{internalDelivery}</>
          ) : (
            <>
              {" " +
                orderAddress.address +
                ", " +
                orderAddress.number +
                (orderAddress.complement
                  ? " " + orderAddress.complement
                  : " ") +
                ", " +
                orderAddress.district +
                " - " +
                orderAddress.city +
                (orderAddress.reference ? " - " + orderAddress.reference : "") +
                (orderAddress.cep ? " - CEP: " + orderAddress.cep : "")}
            </>
          )}
        </p>
      );
    } else return <></>;
  }

  const showModal = () => {
    setModalOpen(true);
  };

  return (
    <div className="success">
      <div className="content-success">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="success-body">
            <div className="success-title">
              {typePluginSpace === "food" ? (
                <img src={SuccessImgFood} alt="Pedido enviado" />
              ) : (
                <img src={SuccessImg} alt="Pedido enviado" />
              )}

              <h1>Seu pedido foi enviado!</h1>
            </div>
            <div className="success-order-details">
              <p>
                <b>Pedido:</b> {orderIdExt}
              </p>
              {externalCodeERP && (
                <p>
                  <b>Pedido Externo:</b> {externalCodeERP}
                </p>
              )}
              <p>
                <b>Data:</b> {orderDate}
              </p>
              <p>
                <b>Modalidade: </b>
                {chooseModality()}
              </p>
              <p>
                {type === "counter" && statusOrder ? (
                  <>
                    <b>Status:</b>
                    {statusOrder.slug === "order_delivered"
                      ? "Recepcionado"
                      : statusOrder.slug === "ready"
                        ? "Concluído"
                        : "Não encontrado"}
                  </>
                ) : (
                  statusOrder && (
                    <>
                      <b>{`Status: `}</b>
                      {statusOrder.slug === "order_delivered" &&
                        type === "withdraw"
                        ? "Retirado"
                        : statusOrder.slug === "packaged" && type === "withdraw"
                          ? "Pronto para retirar"
                          : statusOrder.name}
                    </>
                  )
                )}
              </p>
              <div className="status-payment">
                {type === "counter"
                  ? status?.map((oneStatus, index) => {
                    if (oneStatus.order === 4) {
                      return (
                        <div
                          key={oneStatus.id}
                          className={
                            oneStatus.id === statusOrder?.id
                              ? "status-active success-extreme-left"
                              : "status success-extreme-left"
                          }
                          style={
                            oneStatus.id === statusOrder?.id
                              ? config?.webappcolor.backgroundstatusactive
                                ? {
                                  backgroundColor:
                                    config.webappcolor
                                      .backgroundstatusactive,
                                }
                                : {}
                              : config?.webappcolor.backgroundstatus
                                ? {
                                  backgroundColor:
                                    config.webappcolor.backgroundstatus,
                                }
                                : {}
                          }
                        >
                          <p
                            style={
                              config?.webappcolor.fontstatus
                                ? { color: config?.webappcolor.fontstatus }
                                : {}
                            }
                          >
                            Recepcionado
                          </p>
                        </div>
                      );
                    } else if (oneStatus.order === 5) {
                      return (
                        <div
                          key={oneStatus.id}
                          className={
                            oneStatus.id === statusOrder?.id
                              ? "status-active success-extreme-right"
                              : "status success-extreme-right"
                          }
                          style={
                            oneStatus.id === statusOrder?.id
                              ? config?.webappcolor.backgroundstatusactive
                                ? {
                                  backgroundColor:
                                    config.webappcolor
                                      .backgroundstatusactive,
                                }
                                : {}
                              : config?.webappcolor.backgroundstatus
                                ? {
                                  backgroundColor:
                                    config.webappcolor.backgroundstatus,
                                }
                                : {}
                          }
                        >
                          <p
                            style={
                              config?.webappcolor.fontstatus
                                ? { color: config?.webappcolor.fontstatus }
                                : {}
                            }
                          >
                            Concluído
                          </p>
                        </div>
                      );
                    }
                  })
                  : status?.map((oneStatus, index) => {
                    if (index === 0) {
                      return (
                        <div
                          key={oneStatus.id}
                          className={
                            oneStatus.id === statusOrder?.id
                              ? "status-active success-extreme-left"
                              : "status success-extreme-left"
                          }
                          style={
                            oneStatus.id === statusOrder?.id
                              ? config?.webappcolor.backgroundstatusactive
                                ? {
                                  backgroundColor:
                                    config.webappcolor
                                      .backgroundstatusactive,
                                }
                                : {}
                              : config?.webappcolor.backgroundstatus
                                ? {
                                  backgroundColor:
                                    config.webappcolor.backgroundstatus,
                                }
                                : {}
                          }
                        >
                          <p
                            style={
                              config?.webappcolor.fontstatus
                                ? { color: config?.webappcolor.fontstatus }
                                : {}
                            }
                          >
                            {oneStatus.name}
                          </p>
                        </div>
                      );
                    } else if (index === status.length - 1) {
                      return (
                        <div
                          key={oneStatus.id}
                          className={
                            oneStatus.id === statusOrder?.id
                              ? "status-active success-extreme-right"
                              : "status success-extreme-right"
                          }
                          style={
                            oneStatus.id === statusOrder?.id
                              ? config?.webappcolor.backgroundstatusactive
                                ? {
                                  backgroundColor:
                                    config.webappcolor
                                      .backgroundstatusactive,
                                }
                                : {}
                              : config?.webappcolor.backgroundstatus
                                ? {
                                  backgroundColor:
                                    config.webappcolor.backgroundstatus,
                                }
                                : {}
                          }
                        >
                          <p
                            style={
                              config?.webappcolor.fontstatus
                                ? { color: config?.webappcolor.fontstatus }
                                : {}
                            }
                          >
                            {oneStatus.slug === "order_delivered" &&
                              type === "withdraw"
                              ? "Retirado"
                              : oneStatus.slug === "packaged" &&
                                type === "withdraw"
                                ? "Pronto para retirar"
                                : oneStatus.name}
                          </p>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          key={oneStatus.id}
                          className={
                            oneStatus.id === statusOrder?.id
                              ? "status-active"
                              : "status"
                          }
                          style={
                            oneStatus.id === statusOrder?.id
                              ? config?.webappcolor.backgroundstatusactive
                                ? {
                                  backgroundColor:
                                    config.webappcolor
                                      .backgroundstatusactive,
                                }
                                : {}
                              : config?.webappcolor.backgroundstatus
                                ? {
                                  backgroundColor:
                                    config.webappcolor.backgroundstatus,
                                }
                                : {}
                          }
                        >
                          <p
                            style={
                              config?.webappcolor.fontstatus
                                ? { color: config?.webappcolor.fontstatus }
                                : {}
                            }
                          >
                            {oneStatus.slug === "order_delivered" &&
                              type === "withdraw"
                              ? "Retirado"
                              : oneStatus.slug === "packaged" &&
                                type === "withdraw"
                                ? "Pronto para retirar"
                                : oneStatus.name}
                          </p>
                        </div>
                      );
                    }
                  })}
              </div>
              {statusOrder && statusOrder.slug === "synkar_blocked" && (
                <div className="button-blocked">
                  <MainButton
                    color={
                      config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363"
                    }
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    text="Destravar robô"
                    onClick={async () => await unlockSynkar()}
                  />
                </div>
              )}
            </div>
            <h2 style={{ marginTop: "2em" }}>Informações da compra</h2>
            {orderAddress && (
              <div className="success-order-details">
                <p>
                  <b>Cliente: </b>
                  {name}
                </p>
                {type !== "delivery" && (
                  <p>
                    <b>Loja: </b>
                    {orderAddress.name}
                  </p>
                )}
                {chooseTextAddress(type)}
                {type === "withdraw" &&
                  orderAddress &&
                  orderAddress.otherPersonToWithdrawal && (
                    <p>
                      <b>Responsável pela retirada: </b>
                      {`${orderAddress.otherPersonToWithdrawal.name
                        ? orderAddress.otherPersonToWithdrawal.name
                        : ""
                        } 
											${orderAddress.otherPersonToWithdrawal.cpf
                          ? orderAddress.otherPersonToWithdrawal.cpf
                          : ""
                        }`}
                    </p>
                  )}
              </div>
            )}
            {sellerInfo && (
              <>
                <h2 style={{ marginTop: "2em" }}>Informações do Vendedor</h2>

                <div className="success-order-details">
                  <p>
                    <b>Nome: </b>
                    {sellerInfo.name}
                  </p>
                </div>
              </>
            )}

            <h2 style={{ marginTop: "2em" }}>Produtos</h2>
            {orderFinished &&
              orderFinished.products.map((product) => {
                let priceAdditionals = 0;
                if (product.additionals) {
                  let tempPrice = 0;
                  product.additionals.map(
                    (additional) =>
                      (tempPrice += additional.quantity * additional.price),
                  );
                  priceAdditionals = tempPrice;
                }
                return (
                  <div className="success-order-details" key={product.id}>
                    <div className="product">
                      <div className="product-image">
                        {product.image ? (
                          <ImageLazy
                            name={product.name}
                            image={product.image}
                          />
                        ) : (
                          <div className="no-image" />
                        )}
                      </div>
                      <div className="product-infos">
                        <p>{product.name}</p>
                        {Object.entries(product.variation).map(
                          (variation, index) => {
                            if (
                              variation[0] !== "VARIATION" &&
                              variation[1] !== "NONE"
                            ) {
                              return (
                                <p className="variation" key={index}>
                                  {variation[0] === "NOME_COR"
                                    ? "COR"
                                    : variation[0]}
                                  : <b>{variation[1]}</b>
                                </p>
                              );
                            }
                          },
                        )}
                        {product.additionals && (
                          <div style={{ maxHeight: "4rem", overflowY: "auto" }}>
                            {product.additionals.map((additional, i) => (
                              <p
                                className="additional"
                                key={`additional-${i}`}
                              >{`${additional.quantity}x ${additional.name
                                } (${floatToPrice(additional.price)})`}</p>
                            ))}
                          </div>
                        )}

                        {product.fractions && (
                          <div style={{ maxHeight: "4rem", overflowY: "auto" }}>
                            {organizeFractions(product.fractions).map(
                              (fractional, i) => (
                                <p
                                  className="additional"
                                  key={`fractional-${i}`}
                                >{`${fractional.quantity}/${product.fractions?.length
                                  } ${fractional.name} (${floatToPrice(
                                    fractional.price,
                                  )})`}</p>
                              ),
                            )
                            }
                          </div>
                        )}
                        {product.observation && (
                          <div className="observation">
                            <p>{product.observation}</p>
                          </div>
                        )}
                        {product.unitPrice === product.promotionalPrice ||
                          product.promotionalPrice === 0 ? (
                          <div className="product-values">
                            <div className="values">
                              <p className="promotional">-R$ 0</p>
                              <p>
                                {product.type === "fractional"
                                  ? floatToPrice(
                                    calculatePriceFractionalToProduct(
                                      product,
                                    ) *
                                    product.quantity +
                                    priceAdditionals * product.quantity,
                                  )
                                  : floatToPrice(
                                    product.unitPrice * product.quantity +
                                    priceAdditionals * product.quantity,
                                  )}
                              </p>
                              <p>Quantidade: {product.quantity}</p>
                            </div>
                          </div>
                        ) : (
                          <div className="product-values">
                            <div className="values">
                              <p className="promotional">
                                -
                                {floatToPrice(
                                  product.quantity *
                                  (product.unitPrice -
                                    product.promotionalPrice),
                                )}
                              </p>
                              <p>
                                {floatToPrice(
                                  product.quantity * product.promotionalPrice,
                                )}
                              </p>
                              <p>Quantidade: {product.quantity}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            <div className="infos">
              <div className="row-text">
                <p>Valor dos Produtos</p>
                <p className="value">{floatToPrice(totalWithoutDiscount)}</p>
              </div>
              <div className="row-text">
                <p>Você economiza</p>
                <p>-{floatToPrice(totalWithoutDiscount - total)}</p>
              </div>
              <div className="row-text">
                <p>Valor com desconto</p>
                <p className="value">{floatToPrice(total)}</p>
              </div>
              <div className="row-text">
                <p>Taxa de entrega</p>
                <p className="value">{floatToPrice(freight)}</p>
              </div>
              <div className="row-text-total">
                <p>Total da compra</p>
                <p className="value">{floatToPrice(total + freight)}</p>
              </div>
              <div
                className="row-text cancel-button"
                style={{ marginTop: "0.4rem" }}
              >
                <button onClick={() => showModal()}>
                  Deseja <span>cancelar o seu pedido?</span>
                </button>
              </div>
              {config?.content.pdv.showObservation &&
                observation &&
                observation !== "" && (
                  <div className="observation">
                    <textarea disabled rows={5} className="observation">
                      {observation}
                    </textarea>
                  </div>
                )}
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
      <ModalCancel
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        orderIdExt={orderIdExt}
      />
    </div>
  );
}
